export const SITE_MODULATION_CARD_FRENCH_LOCALE = {
  title: "Modulations",
  count: "Nombre de modulations sur 72h",
  availableSince: "Dispnible depuis",
};
